webpackJsonp([14693037611881],{

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	__webpack_require__(593);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkSectionDescription = function WorkSectionDescription(_ref) {
	  var _ref$content = _ref.content,
	      frontmatter = _ref$content.frontmatter,
	      html = _ref$content.html;
	  return _react2.default.createElement(
	    'div',
	    { className: 'work__section__text col-lg-6' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      frontmatter.title
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      frontmatter.dateRange
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mobile-image' },
	      _react2.default.createElement('img', { src: '/static/images/' + frontmatter.images[0],
	        alt: 'screen shot of work' })
	    ),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } })
	  );
	};
	
	var WorkSectionImages = function WorkSectionImages(_ref2) {
	  var images = _ref2.images;
	  return _react2.default.createElement(
	    'div',
	    { className: 'work__section__images col-lg-6' },
	    images.map(function (src, i) {
	      return _react2.default.createElement('img', { src: '/static/images/' + src,
	        key: src,
	        className: 'work__section__images__' + (i + 1),
	        alt: 'screen shot of work' });
	    })
	  );
	};
	
	var Work = function (_React$Component) {
	  _inherits(Work, _React$Component);
	
	  function Work() {
	    _classCallCheck(this, Work);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Work.prototype.render = function render() {
	    var edges = this.props.data.allMarkdownRemark.edges;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'page work' },
	      _react2.default.createElement(
	        'div',
	        { className: 'work__section na container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(WorkSectionDescription, { content: edges[0].node }),
	          _react2.default.createElement(WorkSectionImages, { images: edges[0].node.frontmatter.images })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__section cap container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(WorkSectionImages, { images: edges[1].node.frontmatter.images }),
	          _react2.default.createElement(WorkSectionDescription, { content: edges[1].node })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__section bfc container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(WorkSectionDescription, { content: edges[2].node }),
	          _react2.default.createElement(WorkSectionImages, { images: edges[2].node.frontmatter.images })
	        )
	      )
	    );
	  };
	
	  return Work;
	}(_react2.default.Component);
	
	exports.default = Work;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-index-js-67d80d7f577ff6e062a5.js